import { Avatar, Tooltip } from "@productlane/ui"

import { useSession } from "@/lib/session"
import { useThreadLockedBy } from "@/lib/states/thread-lock-state"

/**
 * Shows who has a thread open, so a second agent sees the collision before
 * writing a reply. Renders nothing for the reader's own threads.
 */
export function ThreadLockIndicator({ threadId }: { threadId: string }) {
	const { session } = useSession()
	const holder = useThreadLockedBy(threadId, session?.userId)

	if (!holder) return null

	return (
		<Tooltip label={`${holder.name} has this open`} shouldWrapChildren>
			<Avatar
				image={holder.imageUrl}
				name={holder.name}
				size="xs"
				roundness="full"
				className="h-[15px] min-h-[15px] w-[15px] min-w-[15px] ring-1 ring-amber-400 dark:ring-amber-300"
			/>
		</Tooltip>
	)
}
